import { render } from "./Oauth2CallbackPage.vue?vue&type=template&id=02e34eb2"
import script from "./Oauth2CallbackPage.vue?vue&type=script&lang=js"
export * from "./Oauth2CallbackPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__